import styled from "styled-components";

export const MainContainer = styled.main`
  max-width: 1216px;
  margin: 0 auto;
`;